function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "(C)-Archived-Candidates",
  transform: "translate(-157.000000, -803.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(157.000000, 797.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(16.000000, 15.500000) rotate(44.000000) translate(-16.000000, -15.500000) translate(9.000000, 1.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 24,
  width: 14,
  height: 5
}), React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(11.500000, 14.500000) rotate(-270.000000) translate(-11.500000, -14.500000) ",
  points: "-3 12 26 12 26 17 -3 17"
})))));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "25px",
    viewBox: "0 0 32 25",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.d93f6393.svg";
export { ForwardRef as ReactComponent };